import React, { useState } from 'react'
import classNames from 'classnames'
import i18n from '../../../../lib/i18n'
import { allVariants, categoryItemCorrect } from '../../grading'
import Tile, { ItemContent } from './Tile'
import styles from './answers.module.scss'
import own from './AnswerCategories.module.scss'

// type4: tap an item, then tap the category it belongs to; tap a placed item to take it back
function AnswerCategories({ question, draft, onChange, checked, order }) {
  const [selectedId, setSelectedId] = useState(null)
  const groups = question.answers || []
  const byId = Object.fromEntries(allVariants(question).map(_v => [_v._id, _v]))
  const pool = order.filter(id => draft[id] === undefined)

  const place = (groupIndex) => {
    if (!selectedId || checked) return
    onChange({ ...draft, [selectedId]: groupIndex })
    setSelectedId(null)
  }

  const takeBack = (id) => {
    const next = { ...draft }
    delete next[id]
    onChange(next)
  }

  return (
    <div className={styles.stack}>
      {!checked && (
        <div className={styles.pool}>
          {pool.length === 0 && <span className={styles.poolEmpty}>{i18n('qv_all_placed')}</span>}
          {pool.map(id => (
            <Tile
              key={id}
              compact
              aria-pressed={selectedId === id}
              state={selectedId === id ? 'selected' : undefined}
              onClick={() => setSelectedId(selectedId === id ? null : id)}
            >
              <ItemContent item={byId[id]} />
            </Tile>
          ))}
        </div>
      )}

      <div className={own.groups}>
        {groups.map((group, groupIndex) => {
          const placed = order.filter(id => draft[id] === groupIndex)
          return (
            <div
              key={group._id || groupIndex}
              className={classNames(own.group, { [own.target]: Boolean(selectedId) && !checked })}
            >
              <button
                type="button"
                className={own.groupTitle}
                disabled={!selectedId || checked}
                onClick={() => place(groupIndex)}
              >
                {group.url && <img src={group.url} alt="" loading="lazy" />}
                <span>{group.title}</span>
              </button>
              <div className={own.groupItems}>
                {placed.length === 0 && (
                  <button
                    type="button"
                    className={own.dropHint}
                    disabled={!selectedId || checked}
                    onClick={() => place(groupIndex)}
                  >
                    {selectedId ? i18n('qv_place_here') : i18n('qv_empty_category')}
                  </button>
                )}
                {placed.map(id => (
                  <Tile
                    key={id}
                    compact
                    disabled={checked}
                    state={checked ? (categoryItemCorrect(question, id, groupIndex) ? 'correct' : 'wrong') : undefined}
                    aria-label={i18n('qv_take_back')}
                    onClick={() => takeBack(id)}
                  >
                    <ItemContent item={byId[id]} />
                  </Tile>
                ))}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default AnswerCategories
